// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;The wicked boast of their heart&#146;s desire;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the covetous curse and revile the Lord.<br> </p> </div></div>";
// Exports
module.exports = code;